import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type {
  BlockStateUnionType,
  BlockType,
  ComponentTypeUnionType,
} from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';
import { lazy } from 'react';
import type {
  DictationBlockRef,
  DictationBlockStateType,
} from '@unifyapps/defs/blocks/Dictation/types';
import { DictationMethods } from '@unifyapps/defs/blocks/Dictation/types';
import type { Action } from '@unifyapps/defs/types/action';

const importDictationComponent = () =>
  import(
    /* webpackChunkName: "dictation-block" */
    './Dictation'
  );

const Dictation = lazy(importDictationComponent);

class DictationBlockStateDefinition implements BlockStateDefinition {
  useBlockRef?: boolean | undefined = true;

  get type(): ComponentTypeUnionType {
    return 'Dictation';
  }

  get initialStateGetter() {
    return (block: BlockType) =>
      ({
        id: block.id,
        ..._pick(block.component, ['content', 'appearance', 'componentType']),
      }) as BlockStateUnionType;
  }

  getComponent() {
    return Dictation;
  }

  getBlockControlMethods() {
    return [
      {
        id: DictationMethods.StartDictation,
        label: 'Start Dictation',
        method: (
          blockState: DictationBlockStateType,
          action: Action,
          blockRef: DictationBlockRef,
        ) => {
          blockRef.startDictation?.();
          return Promise.resolve();
        },
      },
      {
        id: DictationMethods.StopDictation,
        label: 'Stop Dictation',
        method: (
          blockState: DictationBlockStateType,
          action: Action,
          blockRef: DictationBlockRef,
        ) => {
          blockRef.stopDictation?.();
          return Promise.resolve();
        },
      },
    ];
  }
}

export default DictationBlockStateDefinition;
